'use client'

import React from 'react'

type Props = {
    wavelengthM: number
    wavelengthLabel: string
}

const WIDTH = 340
const HEIGHT = 170
const PAD_LEFT = 14
const PAD_RIGHT = 14
const PAD_TOP = 20
const PAD_BOTTOM = 36
const PLOT_W = WIDTH - PAD_LEFT - PAD_RIGHT
const AMPLITUDE = 40
const CYCLES = 3

export default function WaveformChart({ wavelengthM, wavelengthLabel }: Props) {
    const periodPx = PLOT_W / CYCLES
    const midY = PAD_TOP + AMPLITUDE

    const points: string[] = []
    const steps = 200
    for (let i = 0; i <= steps; i++) {
        const x = (PLOT_W * i) / steps
        const y = midY - AMPLITUDE * Math.sin((2 * Math.PI * x) / periodPx)
        points.push(`${(PAD_LEFT + x).toFixed(1)},${y.toFixed(1)}`)
    }

    const braceX1 = PAD_LEFT + periodPx
    const braceX2 = PAD_LEFT + 2 * periodPx
    const braceY = midY + AMPLITUDE + 16

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* zero line */}
            <line x1={PAD_LEFT} y1={midY} x2={WIDTH - PAD_RIGHT} y2={midY} stroke="#d1d5db" strokeWidth={1} />
            {/* wave */}
            <polyline points={points.join(' ')} fill="none" stroke="#2563eb" strokeWidth={2} />
            {/* wavelength bracket: one full period */}
            <line x1={braceX1} y1={braceY} x2={braceX2} y2={braceY} stroke="#dc2626" strokeWidth={1.5} />
            <line x1={braceX1} y1={braceY - 5} x2={braceX1} y2={braceY + 5} stroke="#dc2626" strokeWidth={1.5} />
            <line x1={braceX2} y1={braceY - 5} x2={braceX2} y2={braceY + 5} stroke="#dc2626" strokeWidth={1.5} />
            <text x={(braceX1 + braceX2) / 2} y={braceY + 16} fontSize={11} textAnchor="middle" fill="#dc2626">
                {wavelengthLabel}
            </text>
        </svg>
    )
}
